import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// // import SwitchAppCheckout from "@switchappgo/staging-switchapp-inline";
// // import { ICheckoutMessageArgs } from "@switchappgo/staging-switchapp-inline/dist/checkout/types";
import SwitchAppCheckout from "@switchappgo/switchapp-inline";
import { ICheckoutMessageArgs } from "@switchappgo/switchapp-inline/dist/checkout/types";

import {
  useBalances,
  useHookForm,
  useMerchantApiMutation,
  useReactRouterLink,
} from "../../../hooks";
import {
  ICreateTopUp,
  IHookForm,
  IModalFormWithTableProps,
  IFormWithTableProps,
  IViewBalance,
  ISwitchAppHostedPageResponse,
} from "../../../interfaces-and-types";
import { globalHandlerUtils } from "../../../utils";

import { View } from "./View";
import { createTopUpSchema } from "./validationSchema";

export interface ICreateTopUpFormViewProps
  extends IHookForm<ICreateTopUp>,
    IModalFormWithTableProps {
  isLoadingBalances: boolean;
  balances: IViewBalance[];
}

export const CreateTopUpForm = (
  props: IFormWithTableProps & {
    goBackOnClose: boolean; // NOTE: used for on-the-fly product creation eg while creating a payment link
  }
) => {
  const { navigate } = useReactRouterLink();
  const location = useLocation();

  const { isLoadingBalances, balances, refreshBalances } = useBalances();

  const closeModal = () => {
    if (props.goBackOnClose) navigate(-1);
    else navigate(location.pathname.replace("/create", ""));
  };

  const switchappClient = new SwitchAppCheckout({
    publicApiKey: "", // used in showHostedPage() mode
  });

  function refreshTopUpTable(args: ICheckoutMessageArgs) {
    closeModal();
    props.refreshTable();
    refreshBalances();
  }

  const {
    isSuccess: isSuccessInitializeTopUp,
    mutate: initializeTopUp,
    data: serviceResponseViewHostedPage,
  } = useMerchantApiMutation<ICreateTopUp, ISwitchAppHostedPageResponse>(
    "createTopUp"
  ).usePostMutation;

  useEffect(() => {
    if (isSuccessInitializeTopUp) {
      reset();

      // navigate to hosted Payment link
      switchappClient
        .showHostedPage({
          ...serviceResponseViewHostedPage.data,

          onClose: refreshTopUpTable,
          onSuccess: refreshTopUpTable,
        })
        .then((p: any) => {
          console.log(`Initialized a new top-up`);
        });
    }
  }, [isSuccessInitializeTopUp]);

  const initialFormValues: ICreateTopUp = {
    amount: 0,
    currency: "",
    wallet_account_tags: [],
  };

  const handleApiSubmit = (data: ICreateTopUp) => {
    initializeTopUp(data);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, errors, register, reset } = useHookForm({
    initialFormValues,
    validationSchema: createTopUpSchema,
    onValid: handleApiSubmit,
    onInvalid: handleError,
  });

  return (
    <View
      {...props}
      isLoadingBalances={isLoadingBalances}
      balances={balances}
      isModalOpen
      closeModal={closeModal}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
    />
  );
};
